/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ProfileUpdateRequest} from '../models/ProfileUpdateRequest';

export interface UpdateAccessRightProfile$Request {
    profileId: number;
    profileUpdateRequest: ProfileUpdateRequest;
}

export interface UpdateAccessRightProfile$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccessRightProfileRequest = createAction<PayloadData<void, UpdateAccessRightProfile$Request>>('UPDATE_ACCESS_RIGHT_PROFILE__UPDATE_ACCESS_RIGHT_PROFILE__REQUEST');
export const updateAccessRightProfileSuccess = createAction<PayloadData<void, UpdateAccessRightProfile$Request>>('UPDATE_ACCESS_RIGHT_PROFILE__UPDATE_ACCESS_RIGHT_PROFILE__SUCCESS');
export const updateAccessRightProfileFailure = createAction<PayloadData<Error, UpdateAccessRightProfile$Request, true>>('UPDATE_ACCESS_RIGHT_PROFILE__UPDATE_ACCESS_RIGHT_PROFILE__FAILURE');

export const updateAccessRightProfileActions = [
    updateAccessRightProfileRequest,
    updateAccessRightProfileSuccess,
    updateAccessRightProfileFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {ProfileUpdateRequest} meta.profileUpdateRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccessRightProfile = (meta: UpdateAccessRightProfile$Request, config?: UpdateAccessRightProfile$Config) => {
    return {
        CALL_API: {
            types: updateAccessRightProfileActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/admins/profiles/${meta.profileId}`,
            TRANSPORT_REQUEST_BODY: meta.profileUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

